<template>
  <div>
    <CBox d="flex" flexDirection="column">
      <OmtRow mb="24px">
        <OmtTypography as="h1-bold" color="var(--colors-light-primary-navy-blue)">Selecione a localidade</OmtTypography>
      </OmtRow>
      <OmtRow mb="16px">
        <CBox>
          <OmtTypography as="h2-bold" color="#4A5E77">Estado</OmtTypography>
          <OmtSelect
            placeholder="Selecione o estado"
            :initialValue="selectedState"
            :disabled="loading"
            @change="onStateSelection"
          >
            <option v-for="(state, index) in states" :key="index"
:value="state.value">
              <OmtTypography as="p3" color="#4A5E77">
                {{ state.label }}
              </OmtTypography>
            </option>
          </OmtSelect>
        </CBox>
      </OmtRow>
      <OmtRow mb="16px">
        <CBox>
          <OmtTypography as="h2-bold" color="#4A5E77">Cidade</OmtTypography>
          <OmtSelect
            placeholder="Selecione a cidade"
            :disabled="!cities.length"
            :initialValue="selectedCity"
            @change="onCitySelection"
          >
            <option v-for="(city, index) in cities" :key="index"
:value="city.value">
              <OmtTypography as="p3" color="#4A5E77">
                {{ city.label }}
              </OmtTypography>
            </option>
          </OmtSelect>
        </CBox>
      </OmtRow>
      <OmtRow mb="24px">
        <CBox>
          <OmtTypography as="h2-bold" color="#4A5E77">Bairro</OmtTypography>
          <OmtSelect
            placeholder="Selecione o bairro"
            :disabled="!neighborhoods.length"
            mb="24px"
            :initialValue="selectedNeighborhood"
            @change="onNeighborhoodSelection"
          >
            <option v-for="(neighborhood, index) in neighborhoods" :key="index"
:value="neighborhood.value">
              <OmtTypography as="p3" color="#4A5E77">
                {{ neighborhood.label }}
              </OmtTypography>
            </option>
          </OmtSelect>
        </CBox>
      </OmtRow>
      <CBox display="flex" justifyContent="center"
mt="auto">
        <OmtButton
          :disabled="!selectedState"
          borderRadius="0px"
          height="40px"
          :w="['100%', '206px !important']"
          @click="submit"
        >
          Continuar
        </OmtButton>
      </CBox>
    </CBox>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";
import { compareTextAsc } from "@/utils/sortUtil";

export default {
  name: "Location",
  data() {
    return {
      loading: false,
      states: [],
      cities: [],
      neighborhoods: []
    };
  },
  computed: {
    ...mapState("openNetworkSearch", ["rede", "selectedEstablishmentType", "selectedSpecialty", "regioesAnonimo"]),
    ...mapGetters("openNetworkSearch", ["getSelectedState", "getSelectedCity", "getSelectedNeighborhood"]),
    selectedState: {
      get() {
        return this.getSelectedState;
      },
      set(value) {
        this.setState(value);
      }
    },
    selectedCity: {
      get() {
        return this.getSelectedCity;
      },
      set(value) {
        this.setCity(value);
      }
    },
    selectedNeighborhood: {
      get() {
        return this.getSelectedNeighborhood;
      },
      set(value) {
        this.setNeighborhood(value);
      }
    }
  },
  async mounted() {
    await this.loadRegioes();

    if (this.selectedState) {
      this.cities = await this.fetchCities();
    }

    if (this.selectedCity) {
      this.neighborhoods = await this.fetchNeighborhoods();
    }
  },
  methods: {
    ...mapActions("openNetworkSearch", ["setState", "setCity", "setNeighborhood", "fetchRegioesAnonimo"]),
    async loadRegioes() {
      this.$root.$emit("show-loading");
      this.loading = true;
      try {
        await this.fetchRegioesAnonimo({
          rede: this.rede,
          tipoAtendimento: this.selectedEstablishmentType?.TipoView,
          codigoEspecialidade: this.selectedSpecialty?.CodigoEspecialidade,
          subEspecialidade: this.selectedSpecialty?.subEspecialidade || ""
        });
        this.states = await this.fetchStates();
      } catch (error) {
        console.error("Erro ao carregar regiões:", error);
      } finally {
        this.loading = false;
        this.$root.$emit("hide-loading");
      }
    },
    async fetchStates() {
      if (!this.regioesAnonimo) return [];
      const states = Object.keys(this.regioesAnonimo).sort(compareTextAsc);
      return states.map(element => ({ value: element, label: element }));
    },
    async fetchCities() {
      try {
        if (!this.regioesAnonimo || !this.selectedState) return [];
        const cities = Object.keys(this.regioesAnonimo[this.selectedState]).sort(compareTextAsc);
        return cities.map(element => ({ value: element, label: element }));
      } catch {
        return [];
      }
    },
    async fetchNeighborhoods() {
      try {
        if (!this.regioesAnonimo || !this.selectedState || !this.selectedCity) return [];
        const neighborhoods = this.regioesAnonimo[this.selectedState][this.selectedCity].sort(compareTextAsc);
        const cache = {};
        const uniqueNeighborhoods = neighborhoods.filter(e => {
          if (cache[e]) {
            return false;
          }
          cache[e] = true;
          return true;
        });
        return uniqueNeighborhoods.map(element => ({ value: element, label: element }));
      } catch {
        return [];
      }
    },
    async onStateSelection(val) {
      this.selectedState = val;
      this.selectedCity = null;
      this.selectedNeighborhood = null;
      this.setState(val);
      this.setCity("");
      this.setNeighborhood("");
      this.cities = await this.fetchCities();
      this.neighborhoods = [];
    },
    async onCitySelection(val) {
      this.selectedCity = val;
      this.selectedNeighborhood = null;
      this.setCity(val);
      this.setNeighborhood("");
      this.neighborhoods = await this.fetchNeighborhoods();
    },
    onNeighborhoodSelection(val) {
      this.selectedNeighborhood = val;
      this.setNeighborhood(val);
    },
    submit() {
      this.$router.push({ name: "network.accredited.list" });
    }
  }
};
</script>
